<p>{{ mesage }}</p>
<app-weighing-scale-input></app-weighing-scale-input>


